import {GenericMenuItem} from "../interfaces/genericMenuItem.ts";
import { MdOutlineSettingsApplications } from "react-icons/md";
import { FaPeopleGroup } from "react-icons/fa6";
import { FaMasksTheater } from "react-icons/fa6";
import { MdOutlineMenuBook } from "react-icons/md";
import {PiFileCsvLight} from "react-icons/pi";


export const seriesModalItems: GenericMenuItem[] = [
  {
    id: "general",
    title: "General",
    icon: MdOutlineSettingsApplications,
  },
  {
    id: "characters",
    title: "Characters",
    icon: FaPeopleGroup,
  },
  {
    id: "genres",
    title: "Genres",
    icon: FaMasksTheater,
  },
  {
    id: "dictionary",
    title: "Dictionary",
    icon: MdOutlineMenuBook,
  },
  {
    id: "externalFiles",
    title: "External Files",
    icon: PiFileCsvLight,
  },
];
